import { render, staticRenderFns } from "./select2Group.vue?vue&type=template&id=0fd46c55"
import script from "./select2Group.vue?vue&type=script&lang=js"
export * from "./select2Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports